export default __webpack_public_path__ + "static/MR@3x-c3de0b2a6fca0ce9904cef02a2133436.png";